let zIndex = 999

export function nextIndex(){
    return ++zIndex
}

export function currIndex(){
    return zIndex
}

export function prevIndex(){
    return zIndex-1
}